import type {UIResourceType} from '@wellstone-solutions/common/models/rest';
import {ALERT_TYPES, showAlert} from 'utils/showAlert';
import {parseValidation} from './schema';

// Announces a successful save, warning when the API couldn't verify some
// contact details. Returns those per-field messages for the form to display.
export const showSavedAlert = (
  validation: UIResourceType['validation'],
): Record<string, string> => {
  const apiErrors = parseValidation(validation);

  if (Object.keys(apiErrors).length > 0) {
    showAlert(
      'Resource saved, but some fields could not be verified',
      ALERT_TYPES.INFO,
    );
  } else {
    showAlert('Successfully saved resource!', ALERT_TYPES.SUCCESS);
  }

  return apiErrors;
};
